module.exports = __webpack_public_path__ + "img/img-quick-03.cb165295.png";